/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import LinkBlock from '../../../../../components/common/LinkBlock/LinkBlock';
import { TTableColumnCell } from '../../../types';
import { TableCell } from '../index';
import TableCellNoValue from '../TableCellNoValue';
import { TTableCellLink } from './types';

function TableCellLink<D extends object>(cell: TTableCellLink<D>): Pick<TTableColumnCell<D>, 'Cell'> {

    return {
        Cell: props => TableCell(props)({
            render: ({ row }) => {
                const { noValue, ...linkProps } = cell(row);
                return !noValue
                    ? <div className="table__tooltip-text">
                        <LinkBlock {...linkProps} />
                    </div>
                    : <TableCellNoValue/>;
            },
        }),
    };
}

export default TableCellLink;
